import { render, staticRenderFns } from "./HeadlineImageField.vue?vue&type=template&id=10a7feca&scoped=true"
import script from "./HeadlineImageField.vue?vue&type=script&lang=ts"
export * from "./HeadlineImageField.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineImageField.vue?vue&type=style&index=0&id=10a7feca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a7feca",
  null
  
)

export default component.exports